function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "365px",
    height: "363px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ededef",
    d: "M 42.5,-0.5 C 135.5,-0.5 228.5,-0.5 321.5,-0.5C 354.443,14.1494 368.776,39.4828 364.5,75.5C 364.5,124.5 364.5,173.5 364.5,222.5C 363.489,256.01 362.322,289.677 361,323.5C 352.948,342.295 339.114,354.795 319.5,361C 299.662,361.168 279.996,361.668 260.5,362.5C 207.5,362.5 154.5,362.5 101.5,362.5C 82.0043,361.668 62.3376,361.168 42.5,361C 25.0245,355.193 12.1912,344.026 4,327.5C 3.66667,324.5 3.33333,321.5 3,318.5C 1.49953,272.345 0.332861,226.345 -0.5,180.5C -0.5,159.5 -0.5,138.5 -0.5,117.5C 0.06736,91.9723 0.900693,66.3056 2,40.5C 9.71169,20.9558 23.2117,7.28913 42.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c82f4",
    d: "M 50.5,39.5 C 137.501,39.3333 224.501,39.5 311.5,40C 316.864,42.0275 321.031,45.5275 324,50.5C 325.958,136.499 325.958,222.499 324,308.5C 320.917,313.588 317.083,318.088 312.5,322C 225.496,323.876 138.496,323.876 51.5,322C 47,318.833 43.1667,315 40,310.5C 39.3333,224.167 39.3333,137.833 40,51.5C 43.2917,47.2 46.7917,43.2 50.5,39.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/blue.85a615723bcb845928c43082a4059d94.svg";
export { ForwardRef as ReactComponent };